export enum EmplifyerListSortEnum {
  Id = 'id',
  Name = 'name',
  Code = 'code',
  ShortCode = 'shortCode',
}
